import React from 'react';
import { Box, Container, Heading, Text, VStack, UnorderedList, ListItem } from '@chakra-ui/react';

const PrivacyPolicy = () => {
    return (
        <Container maxW="4xl" py={10}>
            <VStack align="start" spacing={6}>
                <Heading as="h1" size="xl">Privacy Policy</Heading>
                <Text fontSize="sm" color="gray.500">Last updated: {new Date().toLocaleDateString()}</Text>

                <Text>
                    TickerMood ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how your personal information is collected, used, and disclosed by TickerMood.
                </Text>

                <Heading as="h2" size="lg">1. Information We Collect</Heading>
                <Text>
                    We collect information to provide better services to all our users. The types of information we collect include:
                </Text>
                <UnorderedList pl={4}>
                    <ListItem><strong>Account Information:</strong> When you sign up, we collect your email address and password.</ListItem>
                    <ListItem><strong>Usage Data:</strong> We collect data about how you interact with our services, such as the features you use and the time spent on the app.</ListItem>
                    <ListItem><strong>Device Information:</strong> We may collect information about the device you use to access our services, including the hardware model, operating system, and unique device identifiers.</ListItem>
                    <ListItem><strong>Payment Information:</strong> If you make a purchase, our payment processors (Stripe or Google Play) collect your payment information. We do not store your full credit card details.</ListItem>
                </UnorderedList>

                <Heading as="h2" size="lg">2. How We Use Your Information</Heading>
                <Text>
                    We use the information we collect to:
                </Text>
                <UnorderedList pl={4}>
                    <ListItem>Provide, maintain, and improve our services.</ListItem>
                    <ListItem>Process transactions and send related information, including confirmations and receipts.</ListItem>
                    <ListItem>Send you technical notices, updates, security alerts, and support messages.</ListItem>
                    <ListItem>Respond to your comments, questions, and requests.</ListItem>
                </UnorderedList>

                <Heading as="h2" size="lg">3. Sharing of Information</Heading>
                <Text>
                    We do not share your personal information with third parties except as described in this policy or with your consent. We may share information with:
                </Text>
                <UnorderedList pl={4}>
                    <ListItem><strong>Service Providers:</strong> We use third-party service providers to help us provide our services, such as payment processing (Stripe, Google Play) and hosting.</ListItem>
                    <ListItem><strong>Legal Requirements:</strong> We may disclose information if required to do so by law or in the good faith belief that such action is necessary to comply with a legal obligation.</ListItem>
                </UnorderedList>

                <Heading as="h2" size="lg">4. Data Security</Heading>
                <Text>
                    We take reasonable measures to help protect information about you from loss, theft, misuse, and unauthorized access, disclosure, alteration, and destruction.
                </Text>

                <Heading as="h2" size="lg">5. Your Rights</Heading>
                <Text>
                    You have the right to access, correct, or delete your personal information. You can manage your account settings within the app or contact us for assistance.
                </Text>

                <Heading as="h2" size="lg">6. Changes to This Policy</Heading>
                <Text>
                    We may update this Privacy Policy from time to time. If we make changes, we will notify you by revising the date at the top of the policy and, in some cases, we may provide you with additional notice.
                </Text>

                <Heading as="h2" size="lg">7. Contact Us</Heading>
                <Text>
                    If you have any questions about this Privacy Policy, please contact us at support@tickermood.com.
                </Text>
            </VStack>
        </Container>
    );
};

export default PrivacyPolicy;
